export default __webpack_public_path__ + "static/media/logoTextoTabuleiro.9a4c3712.png";